import { FETCH_ACTIVITY_LOGS_REQUEST, FETCH_ACTIVITY_LOGS_FAILURE, FETCH_ACTIVITY_LOGS_REST, FETCH_ACTIVITY_LOGS_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getActivityLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ACTIVITY_LOGS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ACTIVITY_LOGS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_ACTIVITY_LOGS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ACTIVITY_LOGS_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getActivityLogsReducer;
